<a (click)="action()"
   (keydown.enter)="action()"
   id="skippy"
   tabindex="0"
   class="sr-only sr-only-focusable d-block overflow-hidden position-absolute w-100 bg-white elevation-2 py-2"
   style="z-index: 999999; outline: 1px solid transparent; top: 0;">
  <div class="container-xl">

    <p class="mb-2" *ngIf="startButton != null">
      {{'forms.introduction' | transloco: {name: formMetaInformation.name, organization_name: formMetaInformation.organization_name, page_count: formMetaInformation.pageCount, input_block_count: formMetaInformation.inputBlockCount} }}
    </p>

    <span class="btn btn-light">
      {{(!startButton ? 'base.skip_to_content' : 'base.skip_to_start') | transloco}}
    </span>
  </div>
</a>

<app-design-colors-inserter [design]="formMetaInformation?.designs?.brand" [style.background-color]="formMetaInformation?.designs?.submission?.submission_styles?.body.background_color">
  <app-session-header *ngIf="!isEmbedded && formMetaInformation.requestable"
                      [brandDesign]="formMetaInformation?.designs?.brand"
                      [currentParticipantCompleted]="false"
                      [submissionCompleted]="false"
                      [hasInputs]="false"
                      [mustAcceptTerms]="false"
                      [showApprove]="false"
                      [showCompleteArrow]="false"
                      [showComplete]="false"
                      [showSave]="false"
                      [showFormsNavigation]="true"
                      [showNavigation]="true"
                      [documentName]="formMetaInformation?.name"
                      [showNext]="false"
                      [showPrev]="false"
                      [showReadOnly]="false"
                      [submissionDesign]="formMetaInformation?.designs?.submission"
                      [termsAccepted]="false"
                      (start)="start()">
  </app-session-header>

  <app-forms-preview *ngIf="formMetaInformation.requestable"
                     #scrollcontainer
                     [formMetaInformation]="formMetaInformation"
                     [publicToken]="publicToken"
                     (focusin)="focusStartButton()"
                     (start)="start()"
                     scrollingContainer="session-content">
  </app-forms-preview>

  <pl-form-unavailable *ngIf="!formMetaInformation.requestable"
                       [formName]="formMetaInformation.name"
                       [i18nMessageKey]="'forms.draft_banner'">
  </pl-form-unavailable>
</app-design-colors-inserter>
